import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import axios from "axios";
import { ApiUrl } from '../Constants/Weburl'
import { useNavigate } from "react-router-dom";


export default function Userdetails() {

   const navigate = useNavigate();

   const [users , setUsers ] = useState([]);
  
      const { id } = useParams();
  
      console.log("id users" , id);
  
  
      useEffect(() => {
          fetchSpecificusers()
      },[id])
  
       const fetchSpecificusers = async () => {
      try {
        const token = localStorage.getItem("adminToken");
  
        const res = await axios.get(
            `${ApiUrl}api/auth/specificusers/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
  
        console.log("specific user response", res.data.data);
        setUsers(res.data.data);
      }
      catch (e) {
        console.log("error", e);
      }
    };

     const getImageUrl = (img) => {
    if (!img) return "";
    if (img.startsWith("http")) return img;
    return `${ApiUrl}${img.replace("\\", "/")}`;
  };
  

    return (
         <div className='allpostdetails ud-user-details'>
        <div className="user-details-card">

      {/* Header */}
      <div className="ud-header">
        <div>
          <h4>USER DETAILS</h4>
          <div className="ud-title">
            <span className="ud-name">{users.username}</span>
            <span className="ud-badge">Real</span>
          </div>
          <p className="ud-id">User ID : {users.id}</p>
        </div>

        <button className="edit-btn" onClick={() => navigate(`/editprofile/${users.id}`)}>✎</button>
      </div>

      {/* <hr /> */}

      {/* Body */}
      <div className="ud-body">

        <div className="avatar-big">
            <img
                        src={getImageUrl(users?.avatar)}
                        alt=""
                        style={{
                          width: 80,
                          height: 80,
                          borderRadius: "100%",
                          objectFit: 'cover',
                          objectPosition: 'center'
                        }}
                      />
        </div>

        <h2>{users.username}</h2>
        <p className="subtitle">{users.name}</p>
        
        <div >
         
          {/* <i class="bi bi-gem"></i> */}
          
        <span className="level-badge">
         
          Level:1
          </span>
          </div>

        {/* Stats */}
        <div className="stats">
          <div>
            <h3>{users?.like_posts?.length}</h3>
            <span>Likes</span>
          </div>
          <div>
            <h3>{users?.followers?.length}</h3>
            <span>Followers</span>
          </div>
          <div>
            <h3>{users?.following?.length}</h3>
            <span>Following</span>
          </div>
        </div>

      </div>
    </div>
    </div>
    );
}
